import utils from '@eitje/utils'
import Icon from '../icon'
import './styles/index.less'

export const CollapseChevron = ({open}) => {
	const classNames = utils.makeCnVariants('collapse-chevron', open && 'open')
	return <Icon className={classNames} name="chevron-small-down" />
}
